import { useStore } from '@nanostores/react';
import { description } from './useChatHistory';

export function ChatDescription() {
  const storeDescription = useStore(description);
  const trimmed =
    storeDescription && storeDescription.length > 25 ? storeDescription.slice(0, 25) + '...' : storeDescription;
  return trimmed;
}
